export default __webpack_public_path__ + "static/media/contacts.c726d293.svg";